// extracted by mini-css-extract-plugin
module.exports = {"person":"Person_person__QylHe","pictureWrapper":"Person_pictureWrapper__Cppi1","name":"Person_name__2EDnQ","bio":"Person_bio__2ImoP","personsGrid":"Person_personsGrid__3OKnE"};